export var AIChatConversationTimePeriod;
(function (AIChatConversationTimePeriod) {
    AIChatConversationTimePeriod["TODAY"] = "today";
    AIChatConversationTimePeriod["YESTERDAY"] = "yesterday";
    AIChatConversationTimePeriod["LAST_WEEK"] = "last_week";
    AIChatConversationTimePeriod["LAST_30_DAYS"] = "last_30_days";
    AIChatConversationTimePeriod["OLDER"] = "older";
})(AIChatConversationTimePeriod || (AIChatConversationTimePeriod = {}));
export var PromptSuggestionCategory;
(function (PromptSuggestionCategory) {
    PromptSuggestionCategory["RESEARCH_AND_MONITOR"] = "research_and_monitor";
    PromptSuggestionCategory["ANALYZE_AND_SYNTHESIZE"] = "analyze_and_synthesize";
    PromptSuggestionCategory["START_PROJECT"] = "start_project";
})(PromptSuggestionCategory || (PromptSuggestionCategory = {}));
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["GOOD"] = "good";
    FeedbackType["BAD"] = "bad";
})(FeedbackType || (FeedbackType = {}));
export var FeedbackReason;
(function (FeedbackReason) {
    FeedbackReason["INCORRECT"] = "incorrect";
    FeedbackReason["DIRECTION"] = "direction";
    FeedbackReason["STYLE"] = "style";
    FeedbackReason["OTHER"] = "other";
})(FeedbackReason || (FeedbackReason = {}));
